import * as yup from "yup";
const informacionAlarma35ValidacionEsquema = yup.object().shape({
    dock: yup.mixed().required(),
    razon: yup.mixed().required(),
    detalles: yup.mixed().required(),
    plan: yup.mixed().required(),
    
});

export default informacionAlarma35ValidacionEsquema;
